export type DefaultVehicleDataType = {
    vehicleGroupId: number;
    vehicleGroupName: string;
    maxNumberOfPassengers: number;
    price: number | null;
    priceWithCurrency: string | null;
    imageUrl: string;
}


export const defaultVehicleData: DefaultVehicleDataType[] = [
    {
        vehicleGroupId: 2,
        vehicleGroupName: "Sedan",
        maxNumberOfPassengers: 3,
        price: null,
        priceWithCurrency: null,
        imageUrl: "banner/standard.png"
    },
    {
        vehicleGroupId: 4,
        vehicleGroupName: "Van", 
        maxNumberOfPassengers: 8,
        price: null,
        priceWithCurrency: null,
        imageUrl: "banner/minibus.png"
    },
    {
        vehicleGroupId: 6,
        vehicleGroupName: "Minibus",
        maxNumberOfPassengers: 15,
        price: null,
        priceWithCurrency: null,
        imageUrl: "banner/peopleCarrier.png"
    }
];
